import makeList from './makeList.js'

let viewFloor = '通路棟・防火区画'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '防火区画C',
        file: './data/I59f_C.JPG',
        rotation: -362.8325829074038,
        link: [
          {
            file: './data/I59e_BC.JPG',
            position: [ 4726.6416811468835, 278.23828353828515, -1589.2337288035521 ],
          },
          {
            file: './data/I25a_11.JPG',
            position: [ -2803.790217183739, 925.9604208829622, -4025.487690924903 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 674.3589743589744, 443.58974358974365 ],
          syowaZoom: [ 715.3846153846155, 284.79487179487194 ],
        },
      },
      { description: '防火区画B〜C',
        file: './data/I59e_BC.JPG',
        rotation: -196.35059875334198,
        link: [
          {
            file: './data/I59f_C.JPG',
            position: [ -4775.709189053608, 689.907781965707, 1273.4695301721129 ],
          },
          {
            file: './data/I59d_B.JPG',
            position: [ 4797.75776896641, -93.09421419862424, -1372.4524515392789 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 674.3589743589744, 443.58974358974365 ],
          syowaZoom: [ 618.1353767560664, 270.8544061302681 ],
        },
      },
      { description: '防火区画B',
        file: './data/I59d_B.JPG',
        rotation: -294.8930026187055,
        link: [
          {
            file: './data/I59e_BC.JPG',
            position: [ -4723.134633906987, 377.8178862625582, 1587.4672552465042 ],
          },
          {
            file: './data/I59c_AB.JPG',
            position: [ 4298.252372597442, 328.1207323362143, -2525.444603909771 ],
          },
          {
            file: './data/I26a_21.JPG',
            position: [ -3781.2283915158855, 1112.3009909937425, -3062.8764741522123 ],
          },
          {
            file: './data/I30.JPG',
            position: [ 3890.011765963208, 1140.5828764335404, 2919.613159642819 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 674.3589743589744, 443.58974358974365 ],
          syowaZoom: [ 530.0127713920817, 244.03448275862058 ],
        },
      },
      { description: '防火区画A〜B',
        file: './data/I59c_AB.JPG',
        rotation: -27.471240204294656,
        link: [
          {
            file: './data/I59d_B.JPG',
            position: [ -4666.61722800204, 247.01336583229116, 1749.0212617604575 ],
          },
          {
            file: './data/I18u_A.JPG',
            position: [ 4751.390642070362, 206.273475059874, -1528.339471463803 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 674.3589743589744, 443.58974358974365 ],
          syowaZoom: [ 439.3358876117497, 223.6002554278416 ],
        },
      },
      { description: '防火区画A',
        file: './data/I18u_A.JPG',
        rotation: -306.18612387083556,
        link: [
          {
            file: './data/I59c_AB.JPG',
            position: [ -3980.241640203606, 293.88273359841327, 3000.6782534514587 ],
          },
          {
            file: './data/I59b_A.JPG',
            position: [ 3707.535435679508, 212.09988895128475, -3342.072692034463 ],
          },
          {
            file: './data/I59a_A.JPG',
            position: [ 3097.0205250646814, 93.21246798965662, 3912.356657994654 ],
          },
          {
            file: './data/I21c_2.jpg',
            position: [ -4092.039522087923, 762.1737982996359, -2758.0915540240157 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 674.3589743589744, 443.58974358974365 ],
          syowaZoom: [ 353.7675606641124, 185.28607918263083 ],
        },
      },
      { description: '防火区画A〜発電棟',
        file: './data/I59b_A.JPG',
        rotation: -62.264357560611856,
        link: [
          {
            file: './data/I18u_A.JPG',
            position: [ -3916.5553881215264, 796.0606948466731, 2995.5801344849287 ],
          },
          {
            file: './data/I13a.JPG',
            position: [ 4039.072431125171, -271.8799301975093, -2928.598145662332 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 674.3589743589744, 443.58974358974365 ],
          syowaZoom: [ 277.1392081736909, 145.69476372924646 ],
        },
      },
      { description: '防火区画A〜管理棟',
        file: './data/I59a_A.JPG',
        rotation: -318.6724151429439,
        link: [
          {
            file: './data/I18u_A.JPG',
            position: [ -3712.978262235761, 247.72730743329794, -3333.5988935551914 ],
          },
          {
            file: './data/I18v.JPG',
            position: [ 3456.8045336742434, 320.1885188390008, 3586.8059360061407 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 674.3589743589744, 443.58974358974365 ],
          syowaZoom: [ 318.00766283524905, 215.93742017879947 ],
        },
      },
      { description: '廃棄物集積場',
        file: './data/I30.JPG',
        rotation: -467.707344006782,
        link: [
          {
            file: './data/I59d_B.JPG',
            position: [ -3751.2716806195704, -164.50993740391496, -3291.4987743182996 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 674.3589743589744, 443.58974358974365 ],
          syowaZoom: [ 508.301404853129, 274.6858237547892 ],
        },
      },
      { description: '第１居住棟(１階)',
        file: './data/I25a_11.JPG',
        rotation: -237.69298520735765,
        link: [
          {
            file: './data/I59f_C.JPG',
            position: [ 3393.5962858680364, 378.32181148301726, 3646.788464233819 ],
          },
          {
            file: './data/I25b_12.JPG',
            position: [ 2381.922553337867, 1096.1150503027457, 4251.306763196844 ],
          },
          {
            file: './data/I25_1.JPG',
            position: [ -3938.7300234582663, 1413.3249349305593, -2722.1294610113273 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 715.197956577267, 435.50446998722856 ],
          syowaZoom: [ 766.2835249042146, 259.36015325670496 ],
        },
      },
      { description: '第１居住棟(２階)',
        file: './data/I25b_12.JPG',
        rotation: -117.93866113902752,
        link: [
          {
            file: './data/I25a_11.JPG',
            position: [ -2319.4931406557853, 689.8416852093883, 4365.354089559076 ],
          },
          {
            file: './data/I25_1copy.JPG',
            position: [ -3202.565505271899, 1347.1514516655543, -3588.8654790606342 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 715.197956577267, 435.50446998722856 ],
          syowaZoom: [ 821.2005108556833, 221.0459770114942 ],
        },
      },
      { description: '第１居住棟 室内(１階)',
        file: './data/I25_1.JPG',
        rotation: -215.59629060987896,
        link: [
          {
            file: './data/I25a_11.JPG',
            position: [ 4192.287865049207, 405.3787973251918, -2681.153031434456 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 715.197956577267, 435.50446998722856 ],
          syowaZoom: [ 796.9348659003832, 275.96296296296293 ],
        },
      },
      { description: '第１居住棟 室内(２階)',
        file: './data/I25_1copy.JPG',
        rotation: -210.38941147300199,
        link: [
          {
            file: './data/I25b_12.JPG',
            position: [ -3202.565505271899, 1347.1514516655543, -3588.8654790606342 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 715.197956577267, 435.50446998722856 ],
          syowaZoom: [ 842.911877394636, 233.81736909323104 ],
        },
      },
      { description: '第２居住棟(１階)',
        file: './data/I26a_21.JPG',
        rotation: -118.11053307989147,
        link: [
          {
            file: './data/I59d_B.JPG',
            position: [ 3834.526900835869, 324.9465977158459, 3178.6843743959344 ],
          },
          {
            file: './data/I26_2.JPG',
            position: [ -2893.873118515231, 1273.18629144994, -3865.645076778957 ],
          },
          {
            file: './data/I26_2.JPG',
            position: [ 1967.094356402219, 1451.802695494977, 4356.865823159655 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 666.6666666666667, 424.01021711366536 ],
          syowaZoom: [ 601.5325670498084, 212.10600255427835 ],
        },
      },
      { description: '第２居住棟(２階)',
        file: './data/I26b_22.JPG',
        rotation: -108.04237116802037,
        link: [
          {
            file: './data/I26a_21.JPG',
            position: [ -2211.9015315865004, 659.0188634554021, 4424.26355395788 ],
          },
          {
            file: './data/I26_2copy.JPG',
            position: [ -681.3336626236471, 1606.5863793376377, -4677.106422693596 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 666.6666666666667, 424.01021711366536 ],
          syowaZoom: [ 650.0638569604087, 185.28607918263083 ],
        },
      },
      { description: '第２居住棟 室内(１階)',
        file: './data/I26_2.JPG',
        rotation: -30.806587007492624,
        link: [
          {
            file: './data/I26a_21.JPG',
            position: [ -4446.894168336914, -398.9215777638086, 2235.2022547436336 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 666.6666666666667, 424.01021711366536 ],
          syowaZoom: [ 575.9897828863346, 191.67177522349925 ],
        },
      },
      { description: '第２居住棟 室内(２階)',
        file: './data/I26_2copy.JPG',
        rotation: -29.930875692635198,
        link: [
          {
            file: './data/I26b_22.JPG',
            position: [ -4517.614357079694, -5.244922018867403, 2131.5817043847155 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 666.6666666666667, 424.01021711366536 ],
          syowaZoom: [ 613.0268199233717, 172.51468710089387 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
